import React, { useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Button,
    Box,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Link } from 'react-router-dom';

const ConfirmDialog = ({ isOpen,onClose, isSuccess, message, destination }) => {


    const [isDialogOpen, setDialogOpen] = useState(false);
    const title = ((isSuccess === true) ? 'Success' : 'Error');
    const titleColor = ((isSuccess === true) ? 'green' : 'red');
    const buttonColor = ((isSuccess === true) ? 'success' : 'error');
    const icon = ((isSuccess === true) 
        ? <CheckCircleIcon sx={{width: '60px',  height: '60px' , textAlign:'center' }} color={buttonColor} /> 
        : <ErrorIcon sx={{width: '60px',  height: '60px' , textAlign:'center' }} color={buttonColor} />); 


    const url = '/'+destination;

    return (
        <Dialog open={isOpen} onClose={onClose}>
            {/*<DialogTitle sx={{ bgcolor: titleColor, color: 'white' }}>{title}</DialogTitle>*/}
            <DialogContent>
            <Typography sx={{textAlign: 'center'}} color={titleColor}>{icon}</Typography>
                <Typography variant="h3" sx={{textAlign: 'center'}} color={titleColor} >{title}</Typography>
                <Typography sx={{textAlign: 'center'}}>{message}</Typography>
            </DialogContent>
            <DialogActions>
                {
                    isSuccess               
                    ? <Button variant="contained" type="submit" color={buttonColor} sx={{textAlign: 'center', width: '100%',  height: '60px'}} component={Link} to={url} reloadDocument>
                        Continue
                    </Button>
                    :<Button variant="contained" type="submit" color={buttonColor} sx={{textAlign: 'center', width: '100%',  height: '60px'}} component={Link} onClick={onClose}>
                        Continue
                    </Button>
                }
            </DialogActions>
        </Dialog>

    );
};

export default ConfirmDialog;